import React, {Component} from "react";
import {makeFitImageUrl, makeFitImageUrlWithSize} from "../../../utils";
import {
  catalogClientView, channelCanAddToFavorites, channelPathGenerator, GAevent, getAccessToken,
  getActiveChannel, getActiveClient, getRefreshToken,
  getStoredChannel, homePathGenerator, slugify,
} from "../../../api-client/core/authentication/utils";
import Logo from "../../../assets/img/logo-black.png";
import RichEditor from "../../../components/Letflow/RichTextEditor/EditorialEditor";
import {convertFromRaw, EditorState} from "draft-js";
import {IconButton} from "@material-ui/core";
import {Close, GetApp} from "@material-ui/icons";
import {renderSocialLinksButtons} from "../../../components/Letflow/ContentCreatorViewComponents/SocialBanner";
import styled from "styled-components";
import arrowRight from "../../../components/Letflow/SvgIcons/ico_right.svg";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import style from "./contentCreator.module.css"
import localization from "../../../config/localization";
import GlobalRedirectLoginConfirmationDialog
  from "../../../components/Letflow/Dialog/GlobalRedirectLoginConfirmationDialog";
import browserHistory from "../../../utils/browserHistory";
import {request} from "../../../api-client";
import {get} from "lodash"
import Chip from "@material-ui/core/Chip";
import font from "../HomeElements/Styles/Fonts/fonts.module.css";
import HomeElementCarousel from "../HomeElements/HomeElementCarousel";
import moment from "moment";
import 'moment/locale/es';


export default class EditorialCreator extends Component {
  constructor(props) {
    super(props)
    this.state = {
      contentCreator: this.props.contentCreator,
      favorite: this.props.favorite || false,
      playlist: null,
      description: null,
    };
  }


  componentDidMount = () => {
    if (this.props.contentCreator.hasSuggested) {
      if (this.props.contentCreator.suggestedPlaylist) {
        request.playlist.getForChannel(this.props.contentCreator.suggestedPlaylist.id, 'include=contentCreators;channel').then(playlist => this.setState({playlist}))
      } else {
        this.setState({playlist: null}) //TODO: Aca hay que traer las ultimas notas creadas ordenadas por fecha mas reciente
      }
    }
    this.fixResponsiveEmbedSize();
  };

  fixResponsiveEmbedSize = () => {
    let description = JSON.parse(this.props.contentCreator.description);
    let entityMap = description.entityMap;
    if (entityMap) {
      Object.entries(entityMap).forEach(([k,v]) => {
        let isEmbed = v.type == "EMBEDDED_LINK";
        let isImg = v.type == "IMAGE";
        if ( isEmbed || isImg ) {
          if (v.data && v.data.width) {
            let maxWidth = (window.innerWidth < 650) ? (window.innerWidth - 72) : Math.round(window.innerWidth * 0.6);
            let width = v.data.width.endsWith("px") ? v.data.width.substr(0, v.data.width.length -2) : null;
            if (!width || (width > maxWidth)) {
              if (isEmbed) {
                v.data.width = `${maxWidth}px`;
                v.data.height = `${Math.round(maxWidth/16*9)}px`;
              } else if (isImg) {
                // let ratio = v.data.height / width;
                v.data.width = v.data.width == "auto" ? "auto" : `${maxWidth}px`;
                v.data.height = "auto";
                // v.data.height = `${Math.round(maxWidth * ratio)}px`;
              }
            }
          }
        }
      })
    }
    let contentCreator = this.state.contentCreator;
    contentCreator.description = description.toString();
    this.setState({description: description});
  }

  componentDidUpdate = (prevProps) => {
    if(this.props.contentCreatorId !== prevProps.contentCreatorId) {
    }
  }

  downloadMaterial = (downloadableMaterial) => {
    GAevent('Contenido', "Descargar", this.props.contentCreator.name)
    window.open(
      downloadableMaterial.type === 'image' ? request.contentCreator.downloadMaterial(downloadableMaterial.id)
        : downloadableMaterial[downloadableMaterial.type === 'other' || downloadableMaterial.type === 'link' ? 'binary' : downloadableMaterial.type].url
      , "_blank")
  }

  toggleFavorite = () => {
    if(!getRefreshToken()) {
      GlobalRedirectLoginConfirmationDialog.show({
        title: localization.get("login_redirect"),
        content: getStoredChannel().login_redirect_text || localization.get("login_redirect_text"),
        request: () => new Promise(resolve => {
          browserHistory.push(channelPathGenerator(`login?redirect_to=${this.props.modal ? window.location.pathname+window.location.search : window.location.pathname}`))
          resolve()
        }),
        confirmationLabel: localization.get("login_continue")
      });
    }else {
      this.setState({favorite: !this.state.favorite}, () => {
        if(!getActiveChannel()) {
          request.contentCreatorFavorite[this.state.favorite ? 'add' : 'remove'](this.state.contentCreator.id)
        } else {
          GAevent('Contenido', "Favorite", this.state.contentCreator.name)
          request.contentCreatorChannelFavorite[this.state.favorite ? 'add' : 'remove'](this.state.contentCreator.id)
        }
      })
      this.props.modal && this.props.toggleModalFavorite && this.props.toggleModalFavorite()
    }
  };

  getNoteDate = (date) => {

    return moment(date).locale(localStorage.getItem("default_language")).format(`dddd[${localization.get('time.the')}] D [${localization.get('time.of')}] MMMM`)
  }

  renderPlaylistElements = () => {
    const Container = ({ children }) => <div ref={r => this.resultsTableTags = r} style={{
      float: 'left',
      position: 'relative',
      width: '100%',
      backgroundColor: "white",
    }}>{children}</div>
    let content = <HomeElementCarousel
          {...this.props}
          homeElement={this.makeHomeElementProp(this.state.playlist.contentCreators)}
          dataType={'content_creator'}
          onlyImage={true}
          numbered={false}
          shape={'16:9'}
          columns={4}
          suggestedCarousel
        />

    return <Container>{content}</Container>
  }

  makeHomeElementProp = (contentCreators) => {
    return {
      ...contentCreators,
      items: {
        data: contentCreators.map(item => ({
          ...item,
          title: item.name,
          shortDescription: item.description,
          kind: "content_creator",
        }))
      }
    }
  }

  render = () => {
    let {contentCreator} = this.props;
    let {description} = this.state;

    return (
      <React.Fragment>
        {this.props.modal &&
        <>
        {contentCreator.coverImageUrl && <TopShadow/>}
        <div style={{marginTop: '15px', position: 'absolute',width: '100%'}}>
        <div style={{
          left: (catalogClientView() && this.state.width > 1200) && "66px",
          position: "absolute",
          float: "left",
          width: "auto",
          cursor: "pointer",
          marginLeft: contentCreator.coverImageUrl ? '35px' : '20%',
          filter: contentCreator.coverImageUrl && 'brightness(0) invert(1)',
          zIndex: 5,
        }}>
          <div className="navbar-image-container-link" style={{maxWidth: window.innerWidth < 769 ? "180px" : "auto"}} onClick={() => this.props.onModalClose()}>
            {getActiveChannel() ?
              <img style={{ position: "relative",float: "left", width: "100%", maxWidth: 250, maxHeight: 100}}
                   src={(getStoredChannel() && getStoredChannel().image) ?
                     makeFitImageUrl(getStoredChannel(), 250, 50, '', 'png')
                     :
                     (getStoredChannel() ?
                       makeFitImageUrl(getStoredChannel().client, 250,50, '', 'png')
                       : Logo)}
                   alt={`Logo ${getActiveChannel() ? getStoredChannel().name : "Bloomclouds"}`}/>
              :
              <img
                className="navbar-image" style={{ maxWidth: "130px"}}
                src={(this.state.client && this.state.client.use_logo && this.state.client.image) ?
                  makeFitImageUrlWithSize(this.state.client, 'sm', 'png') :
                  (this.state.client && this.state.client.managedBy && this.state.client.managedBy.image) ?
                    makeFitImageUrlWithSize(this.state.client.managedBy, 'sm', 'png') : Logo}
                alt={`Logo ${getActiveChannel() ? getStoredChannel().name : "Bloomclouds"}`}/>
            }
          </div>
        </div>
          <div style={{
            position: 'absolute',
            float: 'right',
            right: contentCreator.coverImageUrl ? '35px' : '20%',
            filter: contentCreator.coverImageUrl && 'invert(1)',
            zIndex: 5,
          }}>
            <IconButton onClick={() => this.props.onModalClose()}>
              <Close style={{fontSize: "35px"}}/>
            </IconButton>
          </div>
        </div>
        </>
        }
        <div style={{backgroundColor: 'white', display: 'flex', flexDirection: 'column', marginTop: (this.props.modal && !this.props.contentCreator.coverImageUrl) ? 100 : (!this.props.modal && !this.props.contentCreator.coverImageUrl && !this.props.preview) ? 40 : (!this.props.modal && this.props.contentCreator.coverImageUrl && !this.props.preview) ? 20 : 0}}>
          {contentCreator.coverImageUrl ?
            <div>
              <div style={{maxHeight: this.props.modal ? '100vh' : 'calc(100vh - 70px)', overflow: 'hidden', position: "relative"}}>
                <img width="100%" src={contentCreator.coverImageUrl} alt="portada"/>
                <BottomShadow/>
              </div>
              <ArrowBar>
                <div style={{marginLeft: '35px'}}>
                  {this.getNoteDate(contentCreator.activityStart)}
                </div>
                {window.innerWidth > 650 &&
                  <div style={{display: 'flex', placeContent: 'center'}}>
                    <img style={{width: 20, transform: 'rotate(90deg)'}} src={arrowRight} alt={'arrow'}/>
                  </div>
                }
                <SocialButtons>
                  {((!!getActiveClient() && !!getAccessToken() && !getActiveChannel()) || (getActiveChannel() && channelCanAddToFavorites())) &&
                  <>
                  <div style={{top: contentCreator.socialLinks.length === 0 ? 2 : 5}} className={`${style['star']} ${this.state.favorite && style['active']}`}>
                    <Star onClick={this.toggleFavorite}/>
                  </div>
                  <div style={{marginRight: 20, alignSelf: 'center', fontSize: 18, color: '#000'}}>{localization.get('favorite.add')}</div>
                  </>
                  }
                  {contentCreator.downloadableMaterial && (((!!getActiveClient() && !!getAccessToken() && !getActiveChannel()) || (getActiveChannel() && channelCanAddToFavorites()))) &&
                   <hr style={{transform: 'rotate(90deg)', color:'#000', width: 29, margin: '17px 0 0 -15px', filter: 'invert(1)'}}/>
                  }
                  {contentCreator.downloadableMaterial && contentCreator.downloadableMaterial.type !== 'link' &&
                  <>
                    <div style={{top: contentCreator.socialLinks.length === 0 ? 4 : 7, position: 'relative', marginRight: 10, cursor: 'pointer'}}>
                      <GetApp onClick={() => this.downloadMaterial(contentCreator.downloadableMaterial)}/>
                    </div>
                    <div style={{marginRight: 20, alignSelf: 'center', fontSize: 18, color: '#000'}}>{localization.get('download.editorial')}</div>
                  </>
                  }
                  {renderSocialLinksButtons(contentCreator.socialLinks)}
                </SocialButtons>
              </ArrowBar>
            </div>
            :
            <>
            <div>
              <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
                <div style={{marginLeft: '20%', flexGrow: 4}}>
                  {this.getNoteDate(contentCreator.activityStart)}
                </div>
                <SocialButtons style={{marginRight: '20%'}}>
                  {contentCreator.downloadableMaterial && contentCreator.downloadableMaterial.type !== 'link' &&
                  <>
                    <div style={{top: contentCreator.socialLinks.length === 0 ? 8 : 7, position: 'relative', marginRight: 5, cursor: 'pointer'}}>
                      <GetApp onClick={() => this.downloadMaterial(contentCreator.downloadableMaterial)}/>
                    </div>
                    <div style={{marginRight: 10, alignSelf: contentCreator.socialLinks.length === 0 ? 'flex-end' : 'center', color: '#000'}}>{localization.get('download.editorial')}</div>
                  </>
                  }
                  {renderSocialLinksButtons(contentCreator.socialLinks)}
                </SocialButtons>
              </div>
            </div>
            <hr width={'60%'} style={{marginTop: 5}}/>
            </>
          }
          <div style={{padding: "20px 20% 35px"}}>
            <h1 style={{textAlign: 'center'}}>{contentCreator.name}</h1>
            {description && <RichEditor
              editorState={EditorState.createWithContent(convertFromRaw(description))}
              readOnly={true}
              onChange={() => console.log('read only')}
            />}
            {get(contentCreator, 'tags.length', 0) > 0 &&
            <div id={'tags-container'}>
              <h4>{localization.get('tags')}</h4>
              <div style={{marginBottom: 30}}>
                {contentCreator.tags.map((tag, j) => {
                  return (
                    <div className={`smart-search-tag-containter horizontal`}
                         style={{width: "100%", position: "relative", display: "inline-block", marginRight: 10}}>
                      <Chip
                        key={j}
                        className={'editorial-chip'}
                        label={<span className={`${font[getActiveChannel() ? getStoredChannel().preferences.text_font : '']}`}>{tag.name}</span>}
                        onClick={() => {
                          this.props.modal && this.props.onModalClose()
                          this.props.onTagChange && this.props.onTagChange(tag.id)
                          if (getActiveChannel()){
                            browserHistory.push(channelPathGenerator(`busqueda-inteligente/contenido/${contentCreator.type.id}-${slugify(contentCreator.type.name)}?type=${contentCreator.type.slug}&tags_ids=${tag.id}`))
                          } else {
                            browserHistory.push(homePathGenerator(`busqueda-inteligente/contenido/${contentCreator.type.id}-${slugify(contentCreator.type.name)}?type=${contentCreator.type.slug}&tags_ids=${tag.id}`))
                          }
                        }}
                      />
                    </div>
                  )
                })}
              </div>
            </div>
            }

            {contentCreator.hasSuggested && this.state.playlist &&
            <div>
              <h4>{localization.get('related')}</h4>
              {this.renderPlaylistElements()}
            </div>
            }

          </div>
        </div>
      </React.Fragment>
    );
  };
}

const SocialButtons = styled.div`
  display: flex;
  margin-right: 50px;
  place-content: flex-end;
`;

const ArrowBar = styled.div`
  display: grid;
  grid-template-columns: 500px auto 500px;
  margin-top: -55px;
  filter: invert(1);
  align-items: center;
  @media (max-width: 1000px) {
    grid-template-columns: 375px auto 375px;
  }
`;

const BottomShadow = styled.div`
  background: linear-gradient(rgba(0, 0, 0, 0), rgb(0, 0, 0))!important;
  height: 100px;
  position: absolute;
  bottom: -18px;
  right: 0;
  overflow: hidden;
  width: 100%;
`
const TopShadow = styled.div`
  background: linear-gradient(rgb(43 43 43 / 0.8),rgb(76 76 76 / 0))!important;
  height: 100px;
  position: absolute;
  top: -18px;
  right: 0;
  overflow: hidden;
  width: 100%;
  z-index: 1;
`